import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const LandBotChat = dynamic(() => import('./LandBotChat'));

Builder.registerComponent(LandBotChat, {
	name: 'LandBotChat',
	inputs: [
		{
			name: 'chatId',
			required: true,
			friendlyName: 'Chat ID',
			type: 'string',
			defaultValue: 'H-2975580-ZCWI295NZ1UUGWP6',
			helperText: 'The Landbot chat ID (e.g., H-2975580-ZCWI295NZ1UUGWP6)',
		},
		{
			name: 'domain',
			friendlyName: 'Landbot Domain',
			type: 'string',
			defaultValue: 'landbot.pro',
			enum: ['landbot.pro', 'landbot.site'],
			helperText: 'Select the Landbot domain for this chat configuration',
		},
		{
			name: 'height',
			friendlyName: 'Height',
			type: 'string',
			defaultValue: '516px',
			helperText: 'Height of the chat widget (e.g., 516px, 100vh, 50%)',
		},
		{
			name: 'showDynamicPhoneNumber',
			friendlyName: 'Show Dynamic Phone Number',
			type: 'boolean',
			defaultValue: false,
			helperText: 'If true will query for a dynamic phone number',
		},
		{
			name: 'showFinePrint',
			friendlyName: 'Show TCPA',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true will show TCPA. TCPA is REQUIRED for any forms. 
			This option allows it to be removed from the first step`,
		},
		{
			name: 'showLogos',
			friendlyName: 'Show Logos',
			type: 'boolean',
			defaultValue: true,
			helperText: 'If TCPA text is shown this is an option to show or hide logos',
		},
		{
			name: 'finePrint',
			friendlyName: 'Fine Print',
			type: 'richText',
			required: false,
			defaultValue: `<p>
				By clicking &apos;Do I Qualify&apos; and submitting my request,
				I provide my electronic signature and consent to receive phone calls
				and/or text messages from Total Injury Help to the above telephone
				number containing offers to identify a lawyer in its network that may
				assist me. These communications may be generated using an autodialer,
				and/or pre-recorded or artificial voice, and that consent is not required
				to utilize Total Injury Help services. This authorization overrides any
				previous registrations on a federal or state Do Not Call registry. I agree
				to the <a href="/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>
				and <a href="/terms-of-use/" target="_blank" rel="noopener noreferrer">terms</a>
				(including mandatory arbitration and class waiver).
				</p>`,
		},
		{
			name: 'intakeFormId',
			friendlyName: 'Intake Form ID',
			type: 'string',
			helperText: `The form ID of the intake form to show after the form is submitted
			and the user qualifies for an internal intake`,
		},
	],
	image: getIconUrl(Icon.FORM),
});
